// Dependencies
import React, { Fragment } from 'react'

//Components
import { Icon } from 'component-library/icon'
import { Footer, FooterItem } from 'component-library/footer'
import { Link } from 'component-library/link'

// Styles
import * as S from './styles'

// Utils
import {
  dataMedias,
  dataApostilas,
  dataNossosPlanos,
  dataGeneralLinks,
  address
} from 'mocks/footer.mock'

export default () => {
  const scrollToTop = () => {
    window.scroll({ top: 0 })
  }

  return (
    <Footer
      addressLabel={address}
      socialMediaComposition={dataMedias.map((media) => (
        <Link
          key={`link-media-${media.icon}`}
          href={media.link}
          iconElement={
            <Icon
              key={`icon-media-${media.icon}`}
              name={media.icon}
              color="#25272D"
              size={24}
            />
          }
        />
      ))}
      scrollToTopElement={
        <S.ScrollToTopIconWrapper onClick={scrollToTop}>
          <Icon name="arrowLeft" color="#fff" />
        </S.ScrollToTopIconWrapper>
      }
      linksComposition={
        <Fragment>
          <FooterItem
            title="Nossas turmas"
            content={dataNossosPlanos.map((plan) => (
              <Link
                key={`pdg-plan-${plan.name}`}
                variant="footer"
                href={plan.link}
                label={plan.name}
              />
            ))}
          />

          <FooterItem
            title="Apostilas"
            content={dataApostilas.map((book) => (
              <Link
                key={`pdg-book-${book.name}`}
                variant="footer"
                href={book.link}
                label={book.name}
              />
            ))}
          />

          <FooterItem
            content={dataGeneralLinks.map((item) => (
              <Link
                key={`pdg-item-${item.name}`}
                variant="footer"
                label={item.name}
                href={item.link}
              />
            ))}
          />
        </Fragment>
      }
      paymentComposition={
        <Fragment>
          <img
            src="/images/svg/footer/ssl_label_white.svg"
            alt="Certificado SSL de Segurança"
            loading="lazy"
          />

          <FooterItem
            title="Formas de pagamento"
            guidance="horizontal"
            content={
              <Fragment>
                <img loading="lazy" src={'/images/svg/footer/boleto.svg'} />
                <img loading="lazy" src={'/images/svg/footer/visa.svg'} />
                <img loading="lazy" src={'/images/svg/footer/hipercard.svg'} />
                <img loading="lazy" src={'/images/svg/footer/elo.svg'} />
                <img loading="lazy" src={'/images/svg/footer/master.svg'} />
                <img loading="lazy" src={'/images/svg/footer/pix.svg'} />
              </Fragment>
            }
          />
        </Fragment>
      }
    />
  )
}
